import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';

import Home from '@/pages/Home';
import RecipientDetail from '@/pages/RecipientDetail';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminRecipientForm from '@/pages/AdminRecipientForm';
import AdminSettings from '@/pages/AdminSettings';
import AdminShareSettings from '@/pages/AdminShareSettings';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/recipients/:slug" element={<RecipientDetail />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/recipients/new"
                            element={
                                <ProtectedRoute>
                                    <AdminRecipientForm />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/recipients/:id/edit"
                            element={
                                <ProtectedRoute>
                                    <AdminRecipientForm />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/share-settings"
                            element={
                                <ProtectedRoute>
                                    <AdminShareSettings />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/settings"
                            element={
                                <ProtectedRoute>
                                    <AdminSettings />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                    <Toaster
                        position="top-right"
                        theme="dark"
                        toastOptions={{
                            style: { background: '#0a0a0a', color: '#fff', border: '1px solid rgba(255,255,255,0.15)' },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
